export const BOOKING_PARAMS = 'BOOKING_PARAMS';
export const giftCardBookingParams = 'giftCardBookingParams';
